import { EVENT_CART_UPDATE } from "@app/components/cart"
import { formatMoney } from "@app/utils/money"

export class FreeShippingProgressBar extends HTMLElement {
  $reachedIcon: string;
  $notReachedIcon: string;
  $wrapper: HTMLDivElement;
  $iconSlot: HTMLDivElement;
  $messageSlot: HTMLDivElement;
  $progressBar: HTMLDivElement;

  constructor() {
    super()

    this.$reachedIcon = this.querySelector(".reached-icon")?.outerHTML || ""
    this.$notReachedIcon = this.querySelector(".not-reached-icon")?.outerHTML || ""

    this.innerHTML = `
      <div class="mini-cart-free-shipping-tracker flex-col gap-2 p-4 ${this.dataset?.innerClass || ""}">
        <div class="flex gap-2 items-center justify-center">
          <div class="icon-slot"></div>
          <div class="message-slot text-xs text-brand-bistre"></div>
        </div>
        <div class="h-[4px] bg-brand-linen">
          <div class="progress-bar h-full bg-brand-yellow !block transition-all"></div>
        </div>
      </div>
    `

    this.$wrapper = this.querySelector(".mini-cart-free-shipping-tracker")!
    this.$iconSlot = this.querySelector(".icon-slot")!
    this.$messageSlot = this.querySelector(".message-slot")!
    this.$progressBar = this.querySelector(".progress-bar")!

    document.addEventListener(EVENT_CART_UPDATE, async () => {
      if (!this.dataset?.freeShippingThreshold || !window.cart?.total_price) {
        this.classList.add("hidden")
        return
      }

      this.classList.remove("hidden")

      const threshold = parseInt(this.dataset.freeShippingThreshold) * 100
      const remaining = threshold - window.cart.total_price
      const formattedRemaining = formatMoney(remaining)

      this.$progressBar.style.width = `${Math.min(Math.max(window.cart.total_price / threshold * 100, 0), 100)}%`

      if (window.cart.total_price >= threshold) {
        this.$wrapper.classList.add("bg-system-success-10")
        this.$wrapper.classList.remove("bg-brand-cotton")
        this.$iconSlot.innerHTML = this.$reachedIcon
        this.$messageSlot.innerHTML = this.dataset.freeShippingReachedMessage || ""
        this.$progressBar.classList.add("bg-system-success")
        this.$progressBar.classList.remove("bg-brand-yellow")
      } else {
        this.$wrapper.classList.add("bg-brand-cotton")
        this.$wrapper.classList.remove("bg-system-success-10")
        this.$iconSlot.innerHTML = this.$notReachedIcon
        this.$messageSlot.innerHTML = (this.dataset?.freeShippingMessage?.replace("[amount]", formattedRemaining)) || ""
        this.$progressBar.classList.add("bg-brand-yellow")
        this.$progressBar.classList.remove("bg-system-success")
      }
    });
  }
}

customElements.define("free-shipping-progress-bar", FreeShippingProgressBar);
